import React from 'react';
import SmartInput from './SmartInput';

// 04-enforce.md 4.1 -- extraído de SubPanelTratos.jsx (rama `resolvedNodeSub.includes('send-terminal')`
// del tab "Parámetros"): dirección de envío + número de guía con subida/borrado de la foto de
// guía. `renderAutoTextarea`/`renderObservaciones` llegan como render-props (closures sobre el
// estado del container); las mutaciones (`onChangeField`/`onUploadGuidePhoto`/`onDeleteGuidePhoto`)
// son callbacks.
const SubPanelSendTerminal = ({
  formData,
  publicUuid,
  availableVariables,
  savedFields,
  uploadingType,
  uploadProgress,
  documents,
  isCotiza,
  isContrato,
  onChangeField,
  onUploadGuidePhoto,
  onDeleteGuidePhoto,
  renderAutoTextarea,
  renderObservaciones,
}) => {
  const isReadOnly = publicUuid && !formData.is_public;
  const guidePhoto = documents.find(d => d.type === 'foto_guia');

  return (
    <>
      <div className="op-sub-panel-field">
        <label>Dirección de envío</label>
        {renderAutoTextarea("direccion_envio", false, null, { placeholder: "Dirección completa de envío", rows: 4, style: { minHeight: '80px' } }, <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>)}
      </div>

      <div className="op-sub-panel-field">
        <label>Número de guía</label>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <SmartInput
            type="text"
            name="numero_guia"
            value={formData.numero_guia || ''}
            onChange={val => onChangeField('numero_guia', val)}
            placeholder="Número de guía / rastreo"
            availableVariables={publicUuid ? [] : availableVariables}
            style={{
              width: '100%',
              paddingRight: '145px',
              borderColor: savedFields['numero_guia'] ? '#10b981' : '#333',
              transition: 'border-color 0.3s'
            }}
            disabled={isReadOnly}
          />
          <div style={{ position: 'absolute', right: '6px', top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
            {uploadingType === 'foto_guia' ? (
              <span style={{ fontSize: '11px', color: '#10b981', fontWeight: 'bold' }}>Subiendo {uploadProgress}%</span>
            ) : guidePhoto ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-1)' }}>
                <button
                  type="button"
                  onClick={() => window.open(guidePhoto.url, '_blank')}
                  style={{ background: 'rgba(16, 185, 129, 0.15)', border: '1px solid #10b981', color: '#10b981', fontSize: '10px', padding: 'var(--space-1) var(--space-2)', borderRadius: 'var(--radius-sm)', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 'var(--space-1)' }}
                >
                  Ver Guía
                </button>
                <button
                  type="button"
                  aria-label="Eliminar foto de guía"
                  onClick={onDeleteGuidePhoto}
                  style={{ background: 'rgba(239, 68, 68, 0.15)', border: '1px solid #ef4444', color: '#ef4444', fontSize: '10px', padding: 'var(--space-1) var(--space-2)', borderRadius: 'var(--radius-sm)', cursor: 'pointer' }}
                >
                  ✕
                </button>
              </div>
            ) : (
              <button
                type="button"
                onClick={() => document.getElementById('file-foto_guia').click()}
                style={{ background: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.15)', color: '#fff', fontSize: '10px', padding: 'var(--space-1) var(--space-3)', borderRadius: 'var(--radius-sm)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 'var(--space-1)' }}
                disabled={isReadOnly}
              >
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg> Subir Foto
              </button>
            )}
            <input type="file" id="file-foto_guia" style={{ display: 'none' }} onChange={e => onUploadGuidePhoto(e, 'foto_guia')} />
          </div>
        </div>
        {!isCotiza && !isContrato && renderObservaciones('numero_guia')}
      </div>
    </>
  );
};

export default SubPanelSendTerminal;
